"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainlink = void 0;
exports.chainlink = {
    VRFCoordinator: '0x3d2341ADb2D31f1c5530cDC622016af293177AE0',
};
